"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ResourcesModule = /** @class */ (function () {
    function ResourcesModule() {
    }
    return ResourcesModule;
}());
exports.ResourcesModule = ResourcesModule;
